import StorePlatformContractWorkflowCommonLoader from "../libraries/store-platform-contract-workflow-common-loader"
import platformPlanLoad from '../libraries/platform-plan-load'

const StorePlatformContractController = {
  list() {
    document.addEventListener('DOMContentLoaded', () => {
      Array.from(document.getElementsByName('search')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/store_platform_contracts'
          form_element.submit()
        })
      })
      Array.from(document.getElementsByName('list_csv')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/store_platform_contracts_csv/list'
          form_element.submit()
        })
      })
      Array.from(document.getElementsByName('x_passport_csv')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = el.dataset.actionPath
          form_element.submit()
        })
      })
    }, false)
  },

  workflowNew() {
    StorePlatformContractWorkflowCommonLoader()
  },

  workflowCreate() {
    StorePlatformContractWorkflowCommonLoader()
  },

  new() {
    StorePlatformContractWorkflowCommonLoader()
  },

  revise() {
    StorePlatformContractWorkflowCommonLoader()
  },

  addToggleHandler() {
    const setupToggle = (selectTarget, formTarget) => {
      const select = document.querySelector(`[data-toggle-target="${selectTarget}"]`)
      const formDiv = document.querySelector(`[data-toggle-target="${formTarget}"]`)
      if (!select || !formDiv) return

      const toggleForm = () => {
        if (select.value === "true") {
          formDiv.classList.remove("hidden")
        } else {
          formDiv.classList.add("hidden")
        }
      }

      toggleForm()

      select.addEventListener("change", toggleForm)
    }

    // AIでんわ
    setupToggle("aiCallSelect", "aiCallForm")

    // コールセンター転送
    setupToggle("aiSupportSelect", "aiSupportForm")

    // SMS送信
    setupToggle("messageSmsSelect", "messageSmsForm")

    // AIメッセージ
    setupToggle("messageLineSelect", "messageLineForm")

    // メッセージ-LINEチャット対応
    setupToggle("messageLineChatSelect", "messageLineChatForm")

    // AIサブカルテ
    setupToggle("subkarteAiSummarySelect", "subkarteAiSummaryForm")

    // サブカルテ-歯式音声入力
    setupToggle("subkarteDentalFormulasVoiceInputSelect", "subkarteDentalFormulasVoiceInputForm")

    // レセコン-OEMレセコン導入
    setupToggle("oemRececomSelect", "oemRececomForm")

    // レセコン利用設定を入力ボタン
    const applyRececomBtn = document.getElementById('apply-rececom-setting')
    if (applyRececomBtn) {
      applyRececomBtn.addEventListener('click', () => {
        // use_option を "true" に設定
        const useOptionSelect = document.querySelector('[data-toggle-target="oemRececomSelect"]')
        if (useOptionSelect) useOptionSelect.value = "true"

        // hidden field の値を更新
        const useOptionHidden = document.querySelector('input[type="hidden"][name$="[oem_rececom][use_option]"]')
        if (useOptionHidden) useOptionHidden.value = "true"

        // 表示用テキストフィールドを更新
        const useOptionDisplay = document.querySelector('#oem_rececom_use_option_display')
        if (useOptionDisplay) useOptionDisplay.value = "利用する"

        // デフォルト値をセット
        const basicPrice = document.querySelector('.oem_rececom_basic_price')
        if (basicPrice) basicPrice.value = "0"

        const excessiveUnitPrice = document.querySelector('.oem_rececom_excessive_unit_price')
        if (excessiveUnitPrice) excessiveUnitPrice.value = ""

        const freeLimit = document.querySelector('.oem_rececom_free_limit')
        if (freeLimit) freeLimit.value = ""

        // レセコンフォームを表示
        const formDiv = document.querySelector('[data-toggle-target="oemRececomForm"]')
        if (formDiv) formDiv.classList.remove('hidden')

        // レセコン適用フラグをhiddenフィールドとして動的に生成（二重生成防止）
        if (!document.getElementById('apply-rececom-flag')) {
          const applyRececomFlag = document.createElement('input')
          applyRececomFlag.type = 'hidden'
          applyRececomFlag.name = 'store_platform_contract_workflow_for_edit[apply_rececom]'
          applyRececomFlag.value = 'true'
          applyRececomFlag.id = 'apply-rececom-flag'
          applyRececomBtn.closest('form').appendChild(applyRececomFlag)
        }

        // ボタンを非活性に（二重適用防止）
        applyRececomBtn.disabled = true
      })
    }

  },

  setPlatformPlan() {
    const idEl = document.querySelector(".form-control[name$='[platform_plan_id]']")

    platformPlanLoad(idEl.value, () => {
      StorePlatformContractController.addToggleHandler()
    })
  },

  setShopId(shop_id) {
    const storeNameEl = document.getElementById("store_name")
    // 10桁以外は処理しない
    if (!shop_id || shop_id.length !== 10) {
      storeNameEl.value = ""
      return
    }

    fetch(`/api/v1/store/information?shop_id=${shop_id}`)
      .then(response => response.json())
      .then(data => {
        if (!data.store_name) {
          storeNameEl.value = "不正なShop IDです"
          return
        }
        storeNameEl.value = data.store_name
      })
      .catch((error) => {
        console.error('Error:', error)
        storeNameEl.value = ""
      })
  }
}

window.set_platform_plan = () => {
  StorePlatformContractController.setPlatformPlan()
}

window.set_shop_id = (shop_id) => {
  StorePlatformContractController.setShopId(shop_id)
}

document.addEventListener('DOMContentLoaded', () => {
  StorePlatformContractController.addToggleHandler()
})

export default StorePlatformContractController
